module.exports = "dist/logo_gov.png?fba3b404fbabb249766b3af8c36cbc6f";